import PlatformLanguageSelectForm from './PlatformLanguageSelectForm';


export default PlatformLanguageSelectForm;
